var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-flex align-items-center user-select-none" },
    [
      _vm.authControl
        ? _c("label", { class: _vm.classList }, [
            _c(
              "input",
              _vm._b(
                {
                  ref: `switch-${_vm.$attrs.id || "no-id"}`,
                  staticClass: "switch-input form-check-input",
                  attrs: {
                    "false-value": "uncheckedValue",
                    "true-value": "value",
                    type: "checkbox",
                  },
                  domProps: { checked: _vm.value, value: _vm.value },
                  on: {
                    change: _vm.handleChange,
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleClick.apply(null, arguments)
                    },
                  },
                },
                "input",
                _vm.$attrs,
                false
              )
            ),
            _c("span", { staticClass: "switch-slider" }),
          ])
        : _vm._e(),
      _vm.$slots.default || _vm.label
        ? _c(
            "div",
            {
              class: [
                "d-flex align-items-center",
                { "cursor-pointer": !_vm.$attrs.disabled && _vm.authControl },
              ],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  !_vm.$attrs.disabled && _vm.authControl
                    ? _vm.$refs[`switch-${_vm.$attrs.id || "no-id"}`].click()
                    : null
                },
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "align-middle mx-2",
                      class: [
                        { small: _vm.$attrs.size === "sm" },
                        { "text-muted": _vm.$attrs.disabled },
                      ],
                    },
                    [_vm._v(" " + _vm._s(_vm.label) + " ")]
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      !_vm.authControl
        ? _c("font-awesome-icon", {
            class: `text-${_vm.value ? "success" : "danger"}`,
            attrs: { icon: _vm.value ? "check" : "times" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }